import React from 'react';

const BookMeetingCTA: React.FC = () => {
  return (
    <section className="bg-royal-blue py-12 lg:py-16 relative overflow-hidden">
      {/* Decorative circles — hidden on mobile */}
      <div className="absolute left-4 lg:left-[227px] top-1/2 -translate-y-1/2 w-[336px] h-[336px] pointer-events-none hidden lg:block">
        <div
          className="absolute inset-0 rounded-full opacity-5"
          style={{ background: 'radial-gradient(50% 50% at -29% 62%, rgba(137,146,208,1) 3%, rgba(255,255,255,1) 100%)' }}
        />
        <div
          className="absolute left-[44px] top-[44px] w-[248px] h-[248px] rounded-full opacity-5"
          style={{ background: 'radial-gradient(50% 50% at -29% 62%, rgba(137,146,208,1) 3%, rgba(255,255,255,1) 100%)' }}
        />
        <div className="absolute left-[72px] top-[69px] w-[197px] h-[197px] rounded-full bg-[#4452e340] blur-[18px]" />
      </div>

      <div className="max-w-content mx-auto px-6 flex flex-col lg:flex-row items-center gap-8 lg:gap-12 relative z-10">
        {/* Text content — left side */}
        <div className="flex-1">
          <h2 className="font-exo font-black text-white text-3xl lg:text-[42px] tracking-[2.1px] leading-tight">
            Prefer to Talk?
          </h2>
          <h2 className="font-exo font-black text-white text-3xl lg:text-[48px] tracking-[2.4px] leading-tight mt-2">
            Book A Meeting
          </h2>
          <p className="font-proxima text-white text-lg lg:text-2xl tracking-[1.2px] leading-normal mt-6">
            Schedule a consultation with our team to discuss your project directly
          </p>
          <a
            href="#get-started"
            className="inline-flex items-center justify-center rounded-md overflow-hidden bg-white cursor-pointer py-3 px-5 lg:py-4 lg:px-6 hover:bg-opacity-90 transition-colors mt-8"
          >
            <span className="font-proxima-bold font-bold text-royal-blue text-base lg:text-2xl leading-6 whitespace-nowrap">
              GET STARTED
            </span>
          </a>
        </div>

        {/* Meeting photo — right side */}
        <div className="flex-shrink-0 w-full max-w-[220px] lg:max-w-[425px] mx-auto lg:mx-0">
          <img
            className="w-full h-auto object-cover rounded"
            src={require('../assets/img/book-meeting/meeting-photo.png')}
            alt="Team meeting"
          />
        </div>
      </div>
    </section>
  );
};

export default BookMeetingCTA;
